import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';

const RaffleRoutes = loadable(() => pMinDelay(import('./RaffleRoutes'), 300), {
  fallback: <Loading />
});

const AsyncRaffle = props => {
  const pageConfig = {
    headerType: 'mobile-none',
    footerType: 'mobile-none',
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent.device?.type } bg-green hide-betslip hide-sticky-navigation`
      }
    }
  };

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <RaffleRoutes { ...props }/>
    </ApplicationLayout>
  );
};

AsyncRaffle.propTypes = {
  userAgent: PropTypes.object
};

export default AsyncRaffle;
